import { Network } from 'relay-runtime';
import { getAggEndpoint, getRequestBody } from '@atlassian/relay-endpoint';
import { RelayExperimentalApis } from './constants';
function fetchQuery(request, variables, cacheConfig) {
  var endpoint = getAggEndpoint(request, cacheConfig);
  var body = getRequestBody(request, variables);
  return fetch(endpoint, {
    method: 'POST',
    credentials: 'same-origin',
    headers: {
      // Add authentication and other headers here
      'content-type': 'application/json',
      'X-ExperimentalApi': RelayExperimentalApis.join(',')
    },
    body: body
  }).then(function (response) {
    return response.json();
  });
}

// Create a network layer from the fetch function
export var network = Network.create(fetchQuery);